import { Button, Flex } from '@aloft/toolkit-sui';

// eslint-disable-next-line aloft/prefer-sound-ui-button
import { FilterDrawerButton } from './internal/FilterDrawer/FilterDrawerButton.tsx';

export type RecommendedCompsModalFooterToolbarProps = {
  onFilterDrawerOpen: () => void;
  onQualityTiersClick?: () => void;
  onExportCsvClick?: () => void;
};

export const RecommendedCompsModalFooterToolbar = ({
  onFilterDrawerOpen,
  onQualityTiersClick,
  onExportCsvClick,
}: RecommendedCompsModalFooterToolbarProps) => (
  <Flex gap={3}>
    <FilterDrawerButton onFilterDrawerOpen={onFilterDrawerOpen} />
    {onQualityTiersClick !== undefined ? (
      <Button
        icon="quality-tiers"
        size="md"
        variant="secondary"
        text="Quality Tiers"
        __dangerDoNotUseSx={{ padding: '0 14px' }}
        onClick={onQualityTiersClick}
      />
    ) : null}
    {onExportCsvClick !== undefined ? (
      <Button
        icon="download"
        size="md"
        variant="secondary"
        text="Export Comps to CSV"
        __dangerDoNotUseSx={{ padding: '0 14px' }}
        onClick={onExportCsvClick}
      />
    ) : null}
  </Flex>
);
